﻿function getFuelCostsWidgetForm() {
    return $("[data-fuel-costs-widget]");
}

function getCarTaxWidgetForm() {
    return $("[data-car-tax-widget]");
}

function submitCarTaxWidgetForm() {
    const form = getCarTaxWidgetForm();
    form.submit();
}

function submitFuelCostsWidgetForm() {
    const form = getFuelCostsWidgetForm();
    form.submit();
}

export function setupFleetToolsWidget() {
    $(document).on("change", "[data-car-tax-widget-select]", submitCarTaxWidgetForm);
    $(document).on("change", "[data-fuel-costs-widget-select]", submitFuelCostsWidgetForm);
}